import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Popper from "@mui/material/Popper";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import { Box, ButtonGroup, Grid, IconButton } from "@mui/material";
// import Grid from "@mui/material/Grid2";
import TextIncreaseIcon from "@mui/icons-material/TextIncrease";
import TextDecreaseIcon from "@mui/icons-material/TextDecrease";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightlightIcon from "@mui/icons-material/Nightlight";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import { useThemeContext } from "../../App";

export const WcagBox = forwardRef((props, ref) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const popperRef = useRef(null);
  const [fontSize, setFontSize] = useState(16);

  const { theme: themeMode, setTheme } = useThemeContext();
  // console.log("themeMode", themeMode, setTheme);

  //   setTheme("light");

  const handleClick = ({ buttonRef }) => {
    setAnchorEl(anchorEl ? null : buttonRef);
  };

  useImperativeHandle(ref, () => ({
    callChildFunction: (args) => {
      handleClick(args);
    },
  }));

  const open = Boolean(anchorEl);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        anchorEl &&
        popperRef.current &&
        !popperRef.current.contains(event.target) &&
        !anchorEl.contains(event.target)
      ) {
        setAnchorEl(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [anchorEl]);

  const increaseFont = () => {
    const newSize = fontSize + 2;
    if (newSize > 26) return;
    document.documentElement.style.setProperty(
      "--mui-typography-fontSize",
      `${newSize}px`,
    );
    setFontSize(newSize);
  };

  const decreaseFont = () => {
    const newSize = fontSize - 2;
    if (newSize < 10) return;
    document.documentElement.style.setProperty(
      "--mui-typography-fontSize",
      `${newSize}px`,
    );
    setFontSize(newSize);
  };

  return (
    <div>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="top-end"
        transition
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 8],
            },
          },
        ]}
        sx={{
          zIndex: 1500,
        }}
        ref={popperRef}
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <Box sx={{ p: 2 }}>
                {/* <Typography>Accesibility</Typography> */}
                <Grid sx={{ justifyItems: "center" }}>
                  <Grid item size={{ md: 12 }}>
                    <ButtonGroup
                      variant="outlined"
                      aria-label="Basic button group"
                    >
                      <Button
                        sx={{ backgroundColor: "#000" }}
                        onClick={() => setTheme("dark")}
                      >
                        <NightlightIcon
                          fontSize="medium"
                          sx={{ color: "#fff" }}
                        />
                      </Button>
                      <Button
                        sx={{ backgroundColor: "yellow" }}
                        onClick={() => setTheme("contrast")}
                      >
                        <LightModeIcon
                          fontSize="medium"
                          sx={{ color: "#000" }}
                        />
                      </Button>
                      <Button
                        sx={{ backgroundColor: "#fff" }}
                        onClick={() => setTheme("light")}
                      >
                        <LightModeIcon
                          fontSize="medium"
                          sx={{ color: "#000" }}
                        />
                      </Button>
                    </ButtonGroup>
                  </Grid>
                  <Grid item size={{ md: 12 }} sx={{ mt: 1 }}>
                    <ButtonGroup>
                      <IconButton
                        aria-label="text-decrease"
                        size="medium"
                        onClick={() => decreaseFont()}
                      >
                        <TextDecreaseIcon fontSize="inherit" />
                      </IconButton>
                      <IconButton
                        aria-label="text-increase"
                        size="medium"
                        onClick={() => increaseFont()}
                      >
                        <TextIncreaseIcon fontSize="inherit" />
                      </IconButton>
                      <IconButton
                        aria-label="text-increase"
                        size="medium"
                        onClick={() => {
                          setTheme("light");
                          document.documentElement.style.setProperty(
                            "--mui-typography-fontSize",
                            `16px`,
                          );
                        }}
                      >
                        <SettingsBackupRestoreIcon fontSize="inherit" />
                      </IconButton>
                    </ButtonGroup>
                  </Grid>
                </Grid>
              </Box>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
});
